export default __webpack_public_path__ + "static/media/56.fbb220f4.png";